import differenceInMinutes from "date-fns/differenceInMinutes";
import format from "date-fns/format";

export default date => {
   if(!date)
        return;
   const minutesInADay = 1440, minutesInAHour = 60;
   var diffInMinutes = differenceInMinutes(new Date(), new Date(date));
   if(diffInMinutes < minutesInAHour)
         return "prije " + diffInMinutes + "m";
    else if (diffInMinutes >= minutesInAHour && diffInMinutes < minutesInADay) {
       var hours = (diffInMinutes / 60);
       var rhours = Math.floor(diffInMinutes / 60);
       var minutes = (hours - rhours) * 60;
       var rminutes = Math.round(minutes);
       return "prije " + rhours + "h " + rminutes + "m";
    }
    else if(diffInMinutes >= minutesInADay && diffInMinutes < minutesInADay*2)
       return "jučer u " + format(new Date(date), "HH:mm");
    else 
       return format(new Date(date), "dd.MM.yyyy. HH:mm");
};



// WEBPACK FOOTER //
// ./src/common/filters/date/timeAgo.filter.js